import {Map} from 'immutable'
import firedux from '../firedux'
import {getState, dispatch} from '../store'

import {
  ROLES,
  EXPERT_SESSIONS_ENDPOINT,
  EXPERT_SESSIONS_REF_ENDPOINT
} from '../../config/constants'

import getUser from '../getters/user'
import setUserSessionRefs from '../actions/set_user_session_refs'
import removeUserSessionRef from '../actions/remove_user_session_ref'
import setUserSessions from '../actions/set_user_sessions'

const getUsers = (sessions) => {
  Map(sessions).forEach((session) => {
    getUser(session.user)
    getUser(session.expert)
  })
}

const onSessionRefs = (snapshot) => {
  if (snapshot.exists()) dispatch(setUserSessionRefs(snapshot.val()))
}

const onSessionRefRemoved = (childSnapshot) => {
  dispatch(removeUserSessionRef(childSnapshot.key()))
}

const onSessions = (snapshot) => {
  if (snapshot.exists()) {
    const sessions = snapshot.val()
    dispatch(setUserSessions(sessions))
    getUsers(sessions)
  }
  else {
    dispatch(setUserSessions(null))
  }
}

const getOrderKey = (role) => {
  if (role === ROLES.EXPERT || role === ROLES.AUTHOR) {
    return 'expert'
  }
  else {
    return 'user'
  }
}

export const watchCurrentUserSessions = (uid, role) => {
  const REF_ENDPOINT = `${EXPERT_SESSIONS_REF_ENDPOINT}/${uid}`
  const orderKey = getOrderKey(role)

  const refRef = firedux.ref.child(REF_ENDPOINT)
  refRef.on('value', onSessionRefs)
  refRef.on('child_removed', onSessionRefRemoved)

  firedux.ref.child(EXPERT_SESSIONS_ENDPOINT)
  .orderByChild(orderKey).equalTo(uid).on('value', onSessions)
}

export const unwatchCurrentUserSessions = () => {
  const uid = getState().getIn(['currentUser', 'uid'])
  if (!uid) return

  const REF_ENDPOINT = `${EXPERT_SESSIONS_REF_ENDPOINT}/${uid}`

  firedux.ref.child(REF_ENDPOINT).off('value', onSessionRefs)
  firedux.ref.child(REF_ENDPOINT).off('child_removed', onSessionRefRemoved)
  firedux.ref.child(EXPERT_SESSIONS_ENDPOINT).off('value', onSessions)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_user_sessions.js
 **/